import React, { useContext, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { LoginContext } from "./LoginContext";

const ProtectedRoute = () => {
  const { user } = useContext(LoginContext);
  const token = localStorage.getItem("token");
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    if (user !== null || token) {
      setIsChecking(false);
    }
  }, [user, token]);

  if (isChecking) {
    return <div>Loading...</div>; // Wait for state update before deciding
  }

  if (!user || !token) {
    console.warn("No user found, redirecting to /sign-in");
    return <Navigate to="/sign-in" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
